import React from "react";
import MemberHeader from "./MemberHeader";
import { createFallbackTeamMemberAvatar } from "../utils/teamMemberAvatar";

const CalendarHeader = ({ visibleMembers, members }) => (
  <div
    className="calendar-header-row"
    style={{ gridTemplateColumns: `100px repeat(${visibleMembers.length}, minmax(130px, 1fr))` }}
  >
    <div className="time-col"></div>
    {visibleMembers.map(memberName => {
      const member = members.find(m => m.name === memberName) || {
        name: memberName,
        avatar: createFallbackTeamMemberAvatar({ name: memberName, gender: "female" })
      };
      return <MemberHeader key={memberName} member={member} />;
    })}
  </div>
);

export default CalendarHeader;
